import { render } from "./PaymentSelection.vue?vue&type=template&id=2c3dc2ce&scoped=true"
import script from "./PaymentSelection.vue?vue&type=script&lang=js"
export * from "./PaymentSelection.vue?vue&type=script&lang=js"

import "./PaymentSelection.vue?vue&type=style&index=0&id=2c3dc2ce&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3dc2ce"]])

export default __exports__